/*
 * @Author: Dom
 * @Date: 2022-05-18 18:15:06
 * @LastEditTime: 2022-08-03 15:01:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\authent\component\personal\locales\en-US.ts
 */
export default {
    'page.personal.center.compontent.person.message' : 'Personal information',
    'page.personal.center.compontent.person.nationality':'Nationality',
    'page.personal.center.compontent.person.name':'Name',
    'page.personal.center.compontent.person.EnName':'English name',
    'page.personal.center.compontent.person.email':'Mailbox',
    'page.personal.center.compontent.person.phone':'Contact number',
    'page.personal.center.compontent.person.address':'Contact mawb',
    'page.personal.center.compontent.person.addressMod':'Detailed mawb',
    'page.personal.center.compontent.person.select':'Please select',
    'page.personal.center.compontent.person.type':'Document type',
    'page.personal.center.compontent.person.number':'Identification Number',
    'page.personal.center.compontent.person.id':'ID',
    'page.personal.center.compontent.person.passport':'Passport',
    'page.personal.center.compontent.person.certificateTypes':'Pass check',
    'page.personal.center.compontent.person.certificateValidity':'Certificate validity',
    'page.personal.center.compontent.person.effective':'Whether it is long-term effective',
    'page.personal.center.compontent.person.certificate':'Front of certificate',
    'page.personal.center.compontent.person.reverseCertificate':'Reverse side of certificate',
    'page.personal.center.compontent.person.upload':'Please upload a clearly visible photo on the reverse side',
    'page.personal.center.compontent.person.size':'File size no more than 10m',
    'page.personal.center.compontent.person.support':'File format support',
    'page.personal.center.compontent.person.certificatez':'Please upload the front of the clearly visible certificate photo',
    'page.personal.center.compontent.person.submit':'Submit',
    'page.personal.center.compontent.person.reset':'Reset',
}
